import { Link } from "react-router-dom";
import BackgroundLayer from "../components/BackgroundLayer";
import StatusBar from "../components/StatusBar";

function NotFound() {
  return (
    <div className="relative min-h-screen text-bone">
      <BackgroundLayer variant="manifesto" overlay="heavy" />
      <StatusBar />

      <main className="relative z-10 mx-auto flex min-h-[calc(100vh-2.5rem)] max-w-3xl flex-col items-center justify-center px-6 text-center">
        <p className="mb-6 font-display text-base font-light uppercase tracking-[0.18em] text-bone-mute">
          off the map
        </p>
        <h1
          className="font-display text-5xl font-light leading-tight tracking-tight md:text-6xl"
          style={{ textShadow: "0 2px 24px rgba(0,0,0,0.7)" }}
        >
          <span className="block text-bone">YOU'VE WANDERED</span>
          <span
            className="block text-ember-bright"
            style={{
              textShadow:
                "0 0 32px rgba(195,35,35,0.55), 0 2px 24px rgba(0,0,0,0.6)",
            }}
          >
            INTO THE FOG.
          </span>
        </h1>
        <p
          className="mt-8 max-w-md font-display text-base text-bone-dim"
          style={{ textShadow: "0 1px 12px rgba(0,0,0,0.7)" }}
        >
          That path is not on any map we keep. Return to the command surface.
        </p>
        <Link
          to="/"
          className="mt-12 inline-block border border-ember-bright/60 bg-ember/40 px-8 py-3 font-display text-base font-light uppercase tracking-[0.16em] text-bone transition-colors hover:bg-ember/60 hover:shadow-ember-glow"
        >
          ← back to campaigns
        </Link>
      </main>
    </div>
  );
}

export default NotFound;
